import { Link } from 'react-router-dom';
import { Award, CalendarPlus, Unlock, UserCheck, UserPlus, UserX } from 'lucide-react';

export type QuickAction = 'unlock' | 'badge' | 'suspend' | 'activate';

interface QuickActionsProps {
  onAction: (action: QuickAction) => void;
}

const ACTION_CLASS =
  'flex items-center gap-2.5 px-4 py-2.5 rounded-lg border border-border bg-card hover:bg-accent text-sm font-medium text-foreground transition-colors';

function ActionIcon({ icon: Icon }: { icon: React.ElementType }) {
  return (
    <span className="w-8 h-8 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0">
      <Icon className="w-4 h-4" aria-hidden="true" />
    </span>
  );
}

/** What staff reach for most, one click away. */
export default function QuickActions({ onAction }: QuickActionsProps) {
  return (
    <section className="card p-5" aria-labelledby="quick-actions">
      <h2 id="quick-actions" className="text-sm font-semibold text-foreground mb-4">
        Ações rápidas
      </h2>
      <div className="flex flex-wrap gap-3">
        <Link to="/presencas" className={ACTION_CLASS}>
          <ActionIcon icon={UserPlus} />
          Registar entrada
        </Link>
        <Link to="/atividades" className={ACTION_CLASS}>
          <ActionIcon icon={CalendarPlus} />
          Nova atividade
        </Link>
        <button type="button" onClick={() => onAction('badge')} className={ACTION_CLASS}>
          <ActionIcon icon={Award} />
          Atribuir credencial
        </button>
        <button type="button" onClick={() => onAction('unlock')} className={ACTION_CLASS}>
          <ActionIcon icon={Unlock} />
          Desbloquear utilizador
        </button>
        <button type="button" onClick={() => onAction('activate')} className={ACTION_CLASS}>
          <ActionIcon icon={UserCheck} />
          Ativar utilizador
        </button>
        <button type="button" onClick={() => onAction('suspend')} className={ACTION_CLASS}>
          <ActionIcon icon={UserX} />
          Suspender utilizador
        </button>
      </div>
    </section>
  );
}
